import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import addMonths from 'date-fns/add_months';
import addYears from 'date-fns/add_years';
import { getDate } from 'date-fns';
export default {
    namespaced: true,
    state: {
      outbox:[],
      outboxall:[],
      page:1,
      size_page:10,
      results: 0,
      list_month:[],
      allmonth:[],
      multipleRecipients:[      
          {
            image: false,
            email: "",
            firstname: "",
            lastname: "",
            teamName: "",
          },
      ],
      loadingRecipients:true,
      organization:[]
    },
    mutations: {
      setOutbox(state:any, result:any) {
        state.outbox = result
      },
      setOutboxall(state:any, result:any) {
        state.outboxall = result
      },
      setPage(state:any,result:any) {
        state.page = result
      },
      setResults(state:any, result:any) {
        state.results = result
      },
      setList_month(state:any, result:any) {
        state.list_month = result
      },
      setMultipleRecipients(state:any, result:any) {
        state.multipleRecipients = result
      },
      setloadingRecipients(state:any, result:any) {
        state.loadingRecipients = result
      },
      setOutboxallmonth(state:any, result:any) {
        state.allmonth = result
      },
      setOrganization(state:any, result:any) {
        state.organization = result
      },
    },
    actions: {
      async getTeamOrganization1level({commit,rootState,dispatch,state}:any, value:any){
        let result={}
        await firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
        .then((querySnapshot)=> {
                querySnapshot.forEach((doc)=> {
                  const team_id=doc.data().team_id
                  result[team_id]=doc.data().parent
                });
            commit('setOrganization', result)
        });
      },
      async getUser({commit,rootState,dispatch,state}:any, value:any){
        commit("setloadingRecipients",true)
        // console.log("value.to",value.to)
        let _filter:any = _.filter(value.to, { type:"all" });
        let team_filter:any = _.filter(value.to, { type:"team" });
        let user_filter:any = _.filter(value.to, { type:"user" });
        let house_filter:any = _.filter(value.to, { type:"house" });
        const team = (await firebase.database().ref(`team`).orderByChild("company").equalTo(value.company).once('value')).val()
        //const allUserKey={}
        const Alluser:Array<any>=[]
        const user:Array<any>=[]
        for(const childSnapshot in rootState.main.allUser ){
          let _data = rootState.main.allUser[childSnapshot]
          //console.log("_data",_data)
          // const emailKey = _data.email.replace(/\./g, '||')
          // allUserKey[_data.email]=_data
          Alluser.push({image: _data.profilepic,
            email: _data.email,
            firstname: _data.firstname,
            lastname: _data.lastname,
            teamName:  team[_data.team].name,
            houseId:_data.house,
            teamId:  _data.team,})
          
        }


        if(_filter.length>0){
          user.push(...Alluser)
        }
        if(team_filter.length>0){
          for(let value in team_filter){
              
              const id : any= (team_filter[value] && team_filter[value].id )?team_filter[value].id:""
              if(state.organization[id]){
                for(const team_id in state.organization[id]){
                  //console.log("team_filter",team_id)
                  
                  let _team = _.filter(Alluser, (o)=>{
                    return o.teamId == team_id
                  });
                  user.push(..._team)
                }

              }else{
              //console.log("team_filter",id)
              let _team = _.filter(Alluser, (o)=>{
                return o.teamId == id
              });
             
              user.push(..._team)
              }
            
            
          }
        }
        if(user_filter.length>0){
   
          for(let index in user_filter){
              if (user_filter[index] && user_filter[index].email){
                const email: any = user_filter[index].email
                //console.log("user_filter",email)
                let _user = _.filter(Alluser, { email:email });
                user.push(..._user)
              }
           
            
          }
        }
        if(house_filter.length>0){
          let value:any
          for(value in house_filter){
            const id : any= (house_filter[value] && house_filter[value].id)?house_filter[value].id:""
            // console.log("house_filter",id)  
            let house = _.filter(Alluser, { houseId:id });
              user.push(...house)
            
          }
        }

        let users =_.unionBy(user, 'email');
        commit('setMultipleRecipients', users)
        commit("setloadingRecipients",false)
        return users.length
      //   await firebase.database().ref('users').orderByChild("company").equalTo(value.company).once('value', (snapshot) => {
      //     snapshot.forEach((childSnapshot) => {
      //         let _data = childSnapshot.val();
      //         //console.log("_data",_data)
      //         // const emailKey = _data.email.replace(/\./g, '||')
      //         // allUserKey[_data.email]=_data
      //         Alluser.push({image: _data.profilepic,
      //           email: _data.email,
      //           firstname: _data.firstname,
      //           lastname: _data.lastname,
      //           teamName:  team[_data.team].name,
      //           houseId:_data.house,
      //           teamId:  _data.team,})
              
      //     })
      //     if(_filter.length>0){
      //       user.push(...Alluser)
      //     }
      //     if(team_filter.length>0){
      //       for(let value in team_filter){
      //           const id : any= (team_filter[value] && team_filter[value].id )?team_filter[value].id:""
      //           //console.log("team_filter",id)
      //           let _team = _.filter(Alluser, {teamId: id});
      //           user.push(..._team)
              
      //       }
      //     }
      //     if(user_filter.length>0){
     
      //       for(let index in user_filter){
      //           if (user_filter[index] && user_filter[index].email){
      //             const email: any = user_filter[index].email
      //             //console.log("user_filter",email)
      //             let _user = _.filter(Alluser, { email:email });
      //             user.push(..._user)
      //           }
             
              
      //       }
      //     }
      //     if(house_filter.length>0){
      //       let value:any
      //       for(value in house_filter){
      //         const id : any= (house_filter[value] && house_filter[value].id)?house_filter[value].id:""
      //         // console.log("house_filter",id)  
      //         let house = _.filter(Alluser, { houseId:id });
      //           user.push(...house)
              
      //       }
      //     }

      //     let users =_.unionBy(user, 'email');
      //     commit('setMultipleRecipients', users)
      //     commit("setloadingRecipients",false)
  
      // })
      },
      async getData({commit,rootState,dispatch,state}:any, value:any){
        let arrData:Array<any> = [];
        var startAt = ''
        var endAt = ''
        startAt = format(value.start, 'YYYY-MM')+'-01 00:00'
        endAt = format(value.end,'YYYY-MM')+'-31 23:59'
        await firebase.firestore().collection('powerups').where("company", "==", value.user.company).where('createdate','>',startAt).where('createdate','<=',endAt).orderBy('createdate','desc').get()
        .then((querySnapshot)=> {
            querySnapshot.forEach((doc)=> {
              const u = doc.data()
              // console.log("u",u)
              u.id = doc.id
              u.from=value.user.company_name
              if(u.when){
                u.send_on = format(u.when, 'MMM D, YYYY') +" at "+ format(u.when, 'h:mmA')
              }
              if(u.type == 'medal'){
                u.reward = u.medals?u.medals.en:u.medal//rootState.powerups.medalMaster[u.medal]
              }else if(u.type == 'coin'){
                u.reward = u.amount
                if(u.amount > 1){
                  u.unit = "coins"
                }else{
                  u.unit = "coin"
                }
              }else if(u.type == 'gem'){
                u.reward = u.amount
                if(u.amount > 1){
                  u.unit = "gems"
                }else{
                  u.unit = "gem"
                }
              }

              const chk_type_all = _.filter(u.to, { type: "all" });
              if(chk_type_all.length > 0){
                u.send_to = "All Members"
              }else{
                if(u.to.length > 1){
                  u.send_to = "Multiple (" + u.to.length + ")"
                }else{
                  u.send_to = u.to[0].name
                }
              }
              arrData.push(u)
            });
        });
        // if(state.allmonth[format(value.start, 'YYYY-MM')]){
        //   arrData=state.allmonth[format(value.start, 'YYYY-MM')]
        // }else{
        //   arrData=[]
        // }
        // console.log("arrData",arrData)
        arrData = _.orderBy(arrData, ['createdate'], ['desc']),
        commit('setResults',arrData.length)
        commit('setOutboxall', arrData)
        commit('setOutbox', arrData.slice(0, state.size_page))
      },
      async getDataAll({commit,rootState,dispatch,state}:any, value:any){
        let arrData:Array<any> = [];
        let arrDataMonth:Array<any> = [];
        const allUser=rootState.main.allUser

        await firebase.firestore().collection('powerups').where("company", "==",value.user.company ).get()
        .then((querySnapshot)=> {
            querySnapshot.forEach((doc)=> {
              const u = doc.data()
              u.id = doc.id
              if(u.when){
                u.send_on = format(u.when, 'MMM D, YYYY') +" at "+ format(u.when, 'h:mmA')
              }
              u.from=value.user.company_name
              if(u.type == 'medal'){
                u.reward = u.medals?u.medals.en:u.medal//rootState.powerups.medalMaster[u.medal]
              }else if(u.type == 'coin'){
                u.reward = u.amount
                if(u.amount > 1){
                  u.unit = "coins"
                }else{
                  u.unit = "coin"
                }
              }else if(u.type == 'gem'){
                u.reward = u.amount
                if(u.amount > 1){
                  u.unit = "gems"
                }else{
                  u.unit = "gem"
                }
              }

              const chk_type_all = _.filter(u.to, { type: "all" });
              
              if(chk_type_all.length > 0){
                u.send_to = "All Members"
              }
              else{
                let recipients=0
                if(u.to.length > 1){
                  for(const i in u.to){
                    if(u.to[i].type == 'team'){
                      if(state.organization[u.to[i].id]){
                        for(const team_id in state.organization[u.to[i].id]){
                          let _team = _.filter(allUser, {team: team_id});
                          recipients += _team.length
                        }
                      }else{
                        let _team = _.filter(allUser, {team:u.to[i].id});
                        recipients += _team.length
                      }
                    }else if(u.to[i].type == 'house'){
                      let house = _.filter(allUser, { house:u.to[i].id });
                      recipients += house.length
                    }else{
                      recipients += 1
                    }
                  }
                  u.send_to = "Multiple (" + recipients + ")"
                }
                else{
                  if(u.to[0]){
                  u.send_to = u.to[0].name
                  }
                }
              }
              //console.log("u.to[0].name",u.to[0].name)
              arrData.push(u)
              const date=format(u.createdate, 'YYYY-MM')
              if(!arrDataMonth[date]){
                arrDataMonth[date]=[]
              }
              arrDataMonth[date].push(u)
            });
        });
        arrData = _.orderBy(arrData, ['createdate'], ['desc']),
        commit('setResults',arrData.length)
        commit('setOutboxall', arrData)
        commit('setOutboxallmonth', arrDataMonth)
        commit('setOutbox', arrData.slice(0, state.size_page))
      },
      currentChange({commit,state}:any,page:any){
        var size = state.size_page
        var start_row = (page-1) * size
        var end_row = ((page-1) * size)+size
        
        let data: Array<any> = [];
        data.push(state.outboxall)

        commit('setPage',page)
        commit('setOutbox', data[0].slice(start_row,end_row))
      },
      deletePowerup({commit,state,rootState,dispatch}:any,value:any){
        if(value.id){
          firebase.firestore().collection('powerups').doc(value.id).delete().then(function() {
            console.log('Document successfully deleted!',rootState.authen.user);
            dispatch('getDataAll',rootState.authen)
          });
        }
      },
      getList_month({ commit, dispatch, state }: any, user: any) {
        const arr_list_month: Array<any> = [];
        var dateNow = new Date()
        arr_list_month.push({'name':'All-time','id':'All-time'})
        for(let i=0;i<=5;i++){
          arr_list_month.push({'name':format(addMonths(dateNow, -i), 'MMMM YYYY'),'id':format(addMonths(dateNow, -i), 'MMMM YYYY')})
        }
      
        commit('setList_month', arr_list_month)
      },
    },
    getters: {
      outbox : (state:any) => {
        return state.outbox
      },
      outboxall : (state:any) => {
        return state.outboxall
      },
      results : (state:any) => {
        return state.results
      },
      sizepage: (state:any) => {
        return state.size_page
      },
      page : (state:any) => {
        return state.page
      },
      list_month: (state: any) => {
        return state.list_month
      },
      multipleRecipients: (state: any) => {
        return state.multipleRecipients
      },
      loadingRecipients: (state: any) => {
        return state.loadingRecipients
      },
    }
  }